export default "__VITE_ASSET__CA3jv5Gc__"